import {styled} from "@mui/material";
import AddIcon from "assets/icons/AddIcon";
import {useNavigate} from "react-router-dom";

const MobileAddInvoiceButtonContainer = styled("div")(({theme}) => ({
    width: "56px",
    height: "56px",
    backgroundColor: theme.palette.primary.main,
    position: "fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    right: "39px",
    bottom: "39px",
    borderRadius: theme.shape.borderRadius,
    zIndex: 7,
}));

const MobileAddInvoiceButton = () => {
    const navigate = useNavigate();
    return (
        <MobileAddInvoiceButtonContainer onClick={() => navigate("/factors/add")}>
            <AddIcon color="#fff" scale={2}/>
        </MobileAddInvoiceButtonContainer>
    );
};

export default MobileAddInvoiceButton;
